import React from "react";
import { Box, Paper } from "@mui/material";
import { WorkList } from "../../store/types/work.types";
import { useWorkPanel } from "../../hooks/useWorkPanel";
import WorkListItem from "../workitem/WorkListItem";

interface WorkListViewProps {
  works: WorkList[];
}

const WorkListView: React.FC<WorkListViewProps> = ({ works }) => {
  const { openWork } = useWorkPanel();

  return (
    <Box>
      {works.map((work) => (
        <Paper
          key={work.Id}
          elevation={1}
          onClick={() => openWork(work.Id)}
          sx={{
            mb: 1,
            p: 2,
            cursor: "pointer",
            transition: "all 0.15s",
            "&:hover": {
              bgcolor: "action.hover",
              boxShadow: 3,
            },
          }}
        >
          <WorkListItem
            compact
            workType={work.Type}
            title={work.Name}
            customerName={work.Customer?.Name}
            customerId={work.Customer?.CustomerId}
            state={work.State}
            categoryName={work.Category?.Name}
            teamName={work.Team?.Name}
            teamId={work.Team?.Id}
            assignedToName={work.AssignedTo?.Name}
            modified={work.Modified}
          />
        </Paper>
      ))}
    </Box>
  );
};

export default WorkListView;
